import { useState } from "react";
import { Check, Copy, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export const copy = async (text, label = "Copied") => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label);
  } catch {
    toast.error("Clipboard not available");
  }
};

export const SecretField = ({ label, value, testid, mono = true }) => {
  const [show, setShow] = useState(false);
  const [done, setDone] = useState(false);
  const masked = value ? `${value.slice(0, 4)}${"•".repeat(Math.max(4, Math.min(24, value.length - 4)))}` : "— not set —";
  return (
    <div className="space-y-1">
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="flex items-center gap-2 rounded border border-slate-800 bg-slate-950/60 px-3 py-2">
        <span data-testid={testid} className={`flex-1 break-all text-sm text-slate-200 ${mono ? "font-mono" : ""}`}>{show ? value || "— not set —" : masked}</span>
        {value && (
          <>
            <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((s) => !s)} className="text-slate-500 transition-colors hover:text-slate-200">
              {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
            <button type="button" data-testid={`${testid}-copy`} onClick={() => { copy(value); setDone(true); setTimeout(() => setDone(false), 1200); }}
              className="text-slate-500 transition-colors hover:text-slate-200">
              {done ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
